"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputButtonTemplate = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const SmInputButtonTemplate = (_a) => {
    var { icon, className } = _a, props = __rest(_a, ["icon", "className"]);
    const buttonClassnames = (0, classnames_1.default)('c-control__icon', className);
    return (react_1.default.createElement("button", Object.assign({}, props, { tabIndex: props.onClick ? 0 : -1, type: "button", className: buttonClassnames }), icon));
};
exports.SmInputButtonTemplate = SmInputButtonTemplate;
//# sourceMappingURL=button.js.map